import GetBirthdayCalendarViewResponse from 'owa-service/lib/contract/GetBirthdayCalendarViewResponseMessage';
import getBirthdayCalendarViewRequest from 'owa-service/lib/factory/getBirthdayCalendarViewRequest';
import getBirthdayCalendarViewOperation from 'owa-service/lib/operation/getBirthdayCalendarViewOperation';
import { DisplayDate, getEwsRequestString } from 'owa-datetime';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { CalendarId } from 'owa-calendar-cache';
import { getDefaultRequestOptions } from 'owa-headers';

/**
 * Makes the GetBirthdayCalendarView call to the server to get calendar items for birthday calendar
 * @param {Date} rangeStart start of request range
 * @param {Date} rangeEnd end of request range
 * @param {string} folderId folder id of requested calendar
 * @returns promise of GetBirthdayCalendarViewResponse type
 */
export default async function getBirthdayCalendarViewService(
    rangeStart: DisplayDate,
    rangeEnd: DisplayDate,
    calendarId: CalendarId
): Promise<GetBirthdayCalendarViewResponse> {
    const response = await getBirthdayCalendarViewOperation(
        {
            Header: getJsonRequestHeader(),
            Body: getBirthdayCalendarViewRequest({
                StartRange: getEwsRequestString(rangeStart),
                EndRange: getEwsRequestString(rangeEnd),
            }),
        },
        await getDefaultRequestOptions(calendarId.mailboxInfo)
    );

    return response.Body;
}
